import useUser from '@hooks/auth/useUser';
import useAppScheme from '@hooks/native/useAppScheme';
import { PaymentMethod } from '@models/order';

const mode = import.meta.env.VITE_FINGER_PAY_MODE;

interface Props {
    orderNo: string;
    mallId: string;
    requestedAt: string;
    hashString: string;
    itemName: string;
    paymentAmount: number;
    returnUri: string;
    paymentMethod: PaymentMethod;
}

const PaymentCodes : Record<PaymentMethod, string> = {
    KAKAO_PAY: '02',
    PAYCO: '03',
    APPLE_PAY: '13',
    NAVER_PAY: '05',
    CREDIT_CARD: '00',
    PREPAID_CARD: '00',
    TOSS_PAY: '00',
    MOBILE_PAYMENT: '00',
    EASY_CARD: '00',
};

const fingerRegex = /[%&|$\-+=<>]/g;

function useHandleFingerPay() {
    const { user } = useUser();
    const addToForm = ({ form, name, value }:{
        form: HTMLFormElement,
        name: string;
        value: string;
    }) => {
        const input = document.createElement('input');
        input.name = name;
        input.value = value;
        form.append(input);
    };
    const appReturnUrl = useAppScheme();

    return (props: Props) => {
        const {
            orderNo, mallId, requestedAt, hashString, itemName, paymentAmount, returnUri, paymentMethod,
        } = props;
        const original = document
            .querySelector('form[name="payInit"]');
        if (original) {
            original.remove();
        }
        const form = document.createElement('form');
        form.name = 'payInit';
        form.method = 'post';
        form.action = '';
        form.hidden = true;

        addToForm({ form, name: 'payMethod', value: 'CARD' });
        addToForm({ form, name: 'mid', value: mallId });
        addToForm({ form, name: 'payType', value: 'AUTH' });
        // 핑거페이에서 해당 문자열 사용 불가
        addToForm({ form, name: 'goodsNm', value: itemName.replace(fingerRegex, '') });
        addToForm({ form, name: 'ordNo', value: orderNo });
        addToForm({ form, name: 'ordNm', value: user?.nickname.replace(fingerRegex, '') || '고객님' });
        addToForm({ form, name: 'returnUrl', value: returnUri });
        addToForm({ form, name: 'ediDate', value: requestedAt });
        addToForm({ form, name: 'hashString', value: hashString });
        addToForm({ form, name: 'goodsAmt', value: `${paymentAmount}` });
        // addToForm({ form, name: 'appReturnUrl', value: 'platform-stg://' });
        // addToForm({ form, name: 'appCancelUrl', value: 'platform-stg://' });
        if (paymentMethod !== 'CREDIT_CARD') {
            addToForm({ form, name: 'directType', value: '1' });
            addToForm({ form, name: 'directCardCode', value: '00' });
            addToForm({ form, name: 'directCardQuota', value: '00' });
            addToForm({ form, name: 'ezpAuthCd', value: PaymentCodes[paymentMethod] });
        }
        if (appReturnUrl) {
            addToForm({ form, name: 'appReturnUrl', value: `${appReturnUrl}://` });
        }

        document.body.append(form);

        // @ts-ignore
        SendPay(document.payInit, mode);
        return () => {
            form.remove();
        };
    };
}

export default useHandleFingerPay;
